<template>
  <!-- 老師詳細資料頁面 -->
  <div class="profile-container">
    <div :class="themeColor" class="avatar-container">
      <app-avatar :size="128" :id="profile.avatar" />
      <div class="title d-flex justify-center align-center mt-4">
        <span class="mr-3">{{profile.name}}</span>
        <span>{{profile.degree}}</span>
      </div>
    </div>

    <app-card-container>
      <div class="info-list__header">
        <app-favorite-button
          class="ml-auto"
          :isFavorite="profile.isFavorite"
          @click.stop="toggleFavorite(profile)" />

        <v-btn
          @click="chat"
          icon>
          <v-tooltip bottom>
            <v-icon slot="activator">chat</v-icon>
            <span>發送訊息</span>
          </v-tooltip>
        </v-btn>
      </div>
      <app-card>
        <v-card-text>
          <teacher-profile-info :profile="profile" />
        </v-card-text>
      </app-card>
    </app-card-container>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TeacherProfileInfo from './TeacherProfileInfo';

export default {
  components: {
    'teacher-profile-info': TeacherProfileInfo
  },

  computed: {
    ...mapGetters('teacher', {
      profile: 'selectedTeacherProfile'
    })
  },

  methods: {
    ...mapActions('user', {
      toggleContactFavorite: 'toggleContactFavorite'
    }),

    ...mapActions('chat', {
      switchChat: 'switchChat'
    }),

    toggleFavorite(contact) {
      this.toggleContactFavorite({
        id: contact.id,
        username: contact.name,
        isFavorite: contact.isFavorite
      });
    },

    chat() {
      this.switchChat({username: this.profile.username});
      this.changeRightPage('chat');
    }
  }
};
</script>

<style lang="stylus" scoped>

.profile-container {
  overflow-y: auto;
  background-color: $def-bg-color;
  height: 100%;
}

.avatar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
}

.info-list__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.info-list {
  width: 100%;
  padding-left: 0;
}

.info-item {
  display: flex;
  align-items: stretch;
  padding: 1rem;
  min-width: 320px;
  flex-grow: 1;

  &:hover {
    // background-color: $def-hover-color;
  }
}

.info-item__title {
  font-size: 1.1rem;
  margin-right: auto;
  color: rgba(0,0,0,0.8);
}

.info-item__content {
  max-width: 50%;
  text-align: right;
}

.info-item ~ .info-item {
  border-top: 1px solid rgba(0,0,0,0.12);
}

.info-item--self-intro {
  flex-direction: column;
}
</style>
